import { Button } from "@kirvanobr/button";
import { Typography } from "@kirvanobr/typography";

import { ActionButtonProps } from "./ActionButton.types";
import { styles } from "./ActionButton.styles";

export const ActionButton = ({ children, color, startContent, isDisabled, ...otherProps }: ActionButtonProps) => {
  return (
    <Button
      className={styles({ isDisabled }).base()}
      startContent={<div className={styles({ color }).iconWrapper()}>{startContent}</div>}
      size="sm"
      color="tertiary"
      isDisabled={isDisabled}
      {...otherProps}
    >
      <Typography size="t5">{children}</Typography>
    </Button>
  );
};
